// Only navigation/filter parameters are remembered; never creation/action flags.
const keys: Record<string, string[]> = {
  "/users": ["search", "organization_id", "role", "status", "is_test_user", "page"],
  "/whatsapp": ["search", "status", "purpose", "from", "to", "page"],
  "/concerns": ["status", "page"],
  "/admin": ["tab"],
  "/settings": ["tab"]
};
export function listRouteKeys(path: string): readonly string[] {
  return keys[path] ?? (/^\/organizations\/[^/]+$/.test(path) ? ["tab"] : []);
}
